import _classCallCheck from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Component, Children } from 'react';
import PropTypes from 'prop-types';
import storeShape from '../utils/storeShape';
import warning from '../utils/warning';
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = /*#__PURE__*/function (_Component) {
  _inherits(Provider, _Component);

  _createClass(Provider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        store: this.store
      };
    }
  }]);

  function Provider(props, context) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
    _this.store = props.store;
    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      return Children.only(this.props.children);
    }
  }]);

  return Provider;
}(Component);

export { Provider as default };

if (process.env.NODE_ENV !== 'production') {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;

    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: storeShape.isRequired,
  children: PropTypes.element.isRequired
};
Provider.childContextTypes = {
  store: storeShape.isRequired
};